import React, { useEffect, useState } from 'react';
import { Switch, Route } from "react-router-dom";
import { Box, Grid, useMediaQuery } from '@mui/material';
import SignInForm from './SignInForm';
import './LoginView.css'
/* First, import the general dynamic overrides */
import '../../styles/dynamicBackgroundOverrides.css'
import '../../styles/dynamicPortalLogoOverrides.css'
import '../../styles/dynamicDividerColorOverrides.css'
import '../../styles/dynamicPanelColorOverrides.css'
/* Then import the specific overrides in order of importance */
import '../../styles/loginLogoOverrides.css'
import '../../styles/signInFormLogoOverrides.css'
/* Import the background override last to ensure it takes precedence */
import '../../styles/signInFormBackgroundOverrides.css'
import RegistrationForm from './RegistrationForm';
import PasswordResetForm from './PasswordResetForm';
import DynamicResourcesUtils from '../../services/DynamicResourcesUtils';
import MemberService from '../../services/MemberService';
import axios from 'axios';

function LoginView() {
    const [portalTitle, setPortalTitle] = useState('Membership Portal');
    const [portalTitleColor, setPortalTitleColor] = useState('#ffffff'); // Default white
    const isMobileDevice = useMediaQuery(theme => theme.breakpoints.down('md'));
    
    useEffect(() => {
        const source = axios.CancelToken.source();
        
        // Fetch and update portal title
        MemberService.getPortalTitle(source.token)
            .then(data => {
                if (data) {
                    setPortalTitle(data);
                }
            })
            .catch(error => {
                if (!axios.isCancel(error)) {
                    console.error('Error fetching portal title:', error);
                }
            });
            
        // Fetch and update portal title color
        MemberService.getPortalTitleColor(source.token)
            .then(data => {
                if (data) {
                    setPortalTitleColor(data);
                }
            })
            .catch(error => {
                if (!axios.isCancel(error)) {
                    console.error('Error fetching portal title color:', error);
                }
            });
        
        // Initialize the dynamic divider color
        DynamicResourcesUtils.updatePortalDividerColor(source.token)
            .catch(error => {
                if (!axios.isCancel(error)) {
                    console.error('Error initializing portal divider color:', error);
                }
            });
            
        // Initialize the dynamic panel color
        DynamicResourcesUtils.updatePortalPanelColor(source.token)
            .catch(error => {
                if (!axios.isCancel(error)) {
                    console.error('Error initializing portal panel color:', error);
                }
            });
            
        return () => {
            source.cancel();
        };
    }, []);

    return (
        <Box className="login-container" sx={{ flexDirection: { xs: 'column', md: 'row' } }}>
            <Box className="left-panel" sx={{ display: { xs: 'flex', md: 'flex' } }}>
                <div className="logo" />
                {!isMobileDevice && (
                <>
                    <hr/>
                    <div className="title">
                        <h4 
                            dangerouslySetInnerHTML={{ __html: portalTitle.replace(/ /g, '<br/>') }} 
                            style={{ color: portalTitleColor }} 
                        />
                    </div>
                </>
                )}
            </Box> 
            <Grid container justifyContent="center" alignItems="center">
                <Grid item xs={12} sm={8} lg={6} xl={5} className="right-panel">
                    <Switch>
                        <Route path="/signin">
                            <SignInForm />
                        </Route>
                        <Route path="/registration">
                            <RegistrationForm />
                        </Route>
                        <Route path="/recovery">
                            <PasswordResetForm />
                        </Route>
                    </Switch>
                </Grid>
            </Grid>
        </Box>
    );
}

export default LoginView;
